import { render, staticRenderFns } from "./RdbDatastoreSelector.vue?vue&type=template&id=ad677c7e&"
import script from "./RdbDatastoreSelector.vue?vue&type=script&lang=ts&"
export * from "./RdbDatastoreSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports